import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';

import { colors, typography } from '../styles';
// import { colors, typography } from '../../styles';
// import { UnderdogLeft } from '../helpers/UIElements';

const styles = css`
  padding: 80px 0;
  @media(min-width: 992px) {
    padding: 120px 0;
  }
  .AreaInfo_image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 300px;
    @media(min-width: 576px) {
      min-height: 350px;
    }
  }
  .AreaInfo_title {
    /* font-weight: 300;
    font-size: 80px;
    color: #000000;
    letter-spacing: 2.5px; */


    font-weight: 200;
    font-size: 54px;
    color: ${colors.color1};
    font-family: ${typography.Serif};
    margin: 20px 0 60px 0;
    position: relative;
    &:after {
      content: '';
      display: block;
      width: 200px;
      height: 3px;
      position: absolute;
      bottom: -30px;
      left: 0;
      background-color: ${colors.color2};
    }
    @media (min-width: 992px) {
      font-size: 72px;
    }
  }
  .AreaInfo_subtitle {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 25px;
    color: ${colors.color1};
    letter-spacing: 3.75px;
  }
  .AreaInfo_description {
    font-weight: 300;
    font-size: 15px;
    color: #1F1F1F;
    letter-spacing: 0;
    line-height: 28px;
    @media(min-width: 992px) {
      font-size: 17px;
      color: #393939;
      line-height: 30px;
    }
    p:first-of-type {
      font-size: 18px;
      color: #000000;
      line-height: 32px;
      @media(min-width: 992px) {
        font-size: 21px;
        line-height: 40px;
      }
    }
    b {
      font-weight: 700;
      font-size: 16px;
      color: #000000;
      letter-spacing: 2.53px;
      line-height: 25px;
      text-transform: uppercase;
      @media(min-width: 992px) {
        font-size: 18px;
        letter-spacing: 2.84px;
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 100%;
        position: relative;
        margin: 0 0 15px 25px;
        @media(min-width: 768px) {
          margin: 0 0 25px 25px;
          width: calc(46% - 40px);
        }
        &::before {
          content: '';
          width: 10px;
          height: 10px;
          background-color: #808080;
          position: absolute;
          top: 9px;
          left: -25px;
          @media(min-width: 992px) {
            width: 12px;
            height: 12px;
            top: 10px;
          }
        }
      }
    }
  }
  .AreaInfo_content {
    @media(min-width: 992px) {
      padding: 0 40px 0 0;
    }
    @media(min-width: 1290px) {
      padding: 0 70px 0 0;
    }
  }
  .AreaInfo_body {
    font-weight: 300;
    font-size: 19px;
    line-height: 22px;
    color: ${colors.color5};
  }
`;

function AreaInfo({ area }) {
  return (
    <aside className={styles}>
      <div className="container">
        <div className="d-lg-flex mb-4">
          <div
            className="col-lg-6 AreaInfo_image order-lg-1 mb-3 mb-lg-0"
            style={{ backgroundImage: `url('${buildThumbnailUrl(get(area, 'logo.contentUrl'), { width: 800, height: 800 })}')` }}
          />
          <div className="AreaInfo_content">
            {
              // <UnderdogLeft className="d-none d-lg-block">
            }
            <h3 className="AreaInfo_title">Explore</h3>
            <h4 className="AreaInfo_subtitle">{`${get(area, 'name')} Living`}</h4>
            {
              // </UnderdogLeft>
            }
            <div className="AreaInfo_body" dangerouslySetInnerHTML={SanitizeHtml(get(area, 'description'))} />
          </div>
        </div>
      </div>
    </aside>
  );
}

AreaInfo.propTypes = {
  area: PropTypes.object,
};

AreaInfo.defaultProps = {
  area: undefined,
};

export default AreaInfo;



// WEBPACK FOOTER //
// ./src/components/AreaInfo.js